<app-navbar>
</app-navbar>
<!--Main Layout-->
<main class="d-flex  flex-column">
  <div class="container mt-auto p-3">

  <div class="my-lg-3">
        <p>If you are new to Asips please read the instructions   <a routerLink="/help">here.</a></p>

      </div>

<div class="container">
<div class="row justify-content-between">
    <div class="col-md-5">
      <div class="row">
        <div class="input-group my-sm-3">
          <input type="text" class="form-control" placeholder="Number of samples"
                 aria-describedby="button-addon-pretrain" [(ngModel)]="pretrainCount">
          <div class="input-group-append">
<!--            <button mdbBtn color="default" outline="true" size="md" class="m-0 px-3 py-2" type="button" id="button-addon2"-->
<!--                    mdbWavesEffect>Button</button>-->
            <button mdbBtn type="button" size="md" class="white-text m-0 px-3 py-2" rounded="true" mdbWavesEffect style="background-color: #0D446E" id="button-addon-pretrain" (click)="pretrain()">Pre-train</button>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="input-group my-sm-3">
          <input type="text" class="form-control" placeholder="Number of samples"
                 aria-describedby="button-addon-predict" [(ngModel)]="predictCount">
          <div class="input-group-append">
            <!--            <button mdbBtn color="default" outline="true" size="md" class="m-0 px-3 py-2" type="button" id="button-addon2"-->
            <!--                    mdbWavesEffect>Button</button>-->
            <button mdbBtn type="button" size="md" class="white-text m-0 px-3 py-2" rounded="true" mdbWavesEffect style="background-color: #0D446E" id="button-addon-predict" (click)="makePrediction()">Predict</button>

          </div>
        </div>
      </div>

      <div class="row">
            <button mdbBtn type="button" class="white-text my-sm-3 white-text px-6 py-2" rounded="true" mdbWavesEffect style="background-color: #0D446E" [routerLink]="'/verify'">Verify, Update Model and See Current Accuracy</button>
      </div>
      <div class="row mt-xl-5">

        <mdb-card class="example-1 scrollbar-morpheus-den">
          <mdb-card-body>
            <mdb-card-title>
            <h4 id="section1">Log</h4>
            </mdb-card-title>
              <mdb-card-text class="flex-column">
                <ng-container *ngFor="let item of logText">
                <p>{{item}}</p>
                </ng-container>
              </mdb-card-text>
          </mdb-card-body>
        </mdb-card>
      </div>

      </div>

  <!-- Card -->
  <div class="col-md-5">
    <div class="row-4 m-md-3">
  <mdb-card>
    <div class="view rgba-white-slight waves-light" mdbWavesEffect>
    </div>
    <!--Card content-->
    <mdb-card-body>
      <!--Title-->
      <mdb-card-title>
        <h4>Pre-Train Info</h4>
      </mdb-card-title>

      <!--Text-->
      <mdb-card-text class="flex-column">
        <p>Time Difference: {{ pretrainInfo.timeDifference}} μs<br></p>
        <p>Info: {{ pretrainInfo.info }}<br></p>
        <p>Number of Learning Samples: {{ pretrainInfo.numberOfLearningSamples }}<br></p>
        <p>Features: {{ pretrainInfo.features }}<br></p>
        <p>Target Values: {{ pretrainInfo.targetValues }}<br></p>
      </mdb-card-text>
    </mdb-card-body>
  </mdb-card>
    </div>

    <div class="row-4 m-md-3">
      <mdb-card>
        <div class="view rgba-white-slight waves-light" mdbWavesEffect>
        </div>
        <!--Card content-->
        <mdb-card-body>
          <!--Title-->
          <mdb-card-title>
            <h4>Last Stream Prediction Info - (Current Accuracy)</h4>
          </mdb-card-title>

          <!--Text-->
          <mdb-card-text *ngIf="evaluationMeasures.confirmationState == 0" class="flex-column">
            <p style="color: #EC407A">Number of samples of last batch: {{ evaluationMeasures.samples }}<br></p>
            <p style="color: #EC407A">Kappa: {{ evaluationMeasures.kappa }}<br></p>
            <p style="color: #EC407A">G-Mean: {{ evaluationMeasures.gMean }}<br></p>
            <p style="color: #EC407A">Accuracy: {{ evaluationMeasures.accuracy }}<br></p>
            <p style="color: #EC407A">Recall: {{ evaluationMeasures.recall }}<br></p>
            <p style="color: #EC407A">Precision: {{ evaluationMeasures.precision }}<br></p>
            <p style="color: #EC407A">F1 Score: {{ evaluationMeasures.fScore }}<br></p>
          </mdb-card-text>
          <mdb-card-text *ngIf="evaluationMeasures.confirmationState == 1" class="flex-column text-success">
            <p>Number of samples of last batch: {{ evaluationMeasures.samples }}<br></p>
            <p>Kappa: {{ evaluationMeasures.kappa }}<br></p>
            <p>G-Mean: {{ evaluationMeasures.gMean }}<br></p>
            <p>Accuracy: {{ evaluationMeasures.accuracy }}<br></p>
            <p>Recall: {{ evaluationMeasures.recall }}<br></p>
            <p>Precision: {{ evaluationMeasures.precision }}<br></p>
            <p>F1 Score: {{ evaluationMeasures.fScore }}<br></p>
          </mdb-card-text>

        </mdb-card-body>
      </mdb-card>
    </div>
    <div class="row-4 m-md-3">
      <mdb-card>
        <div class="view rgba-white-slight waves-light" mdbWavesEffect>
        </div>
        <!--Card content-->
        <mdb-card-body>
          <!--Title-->
          <mdb-card-title>
            <h4>Current Mean Accuracy</h4>
          </mdb-card-title>

          <!--Text-->
          <mdb-card-text *ngIf="evaluationMeanMeasures.confirmationState == 0" class="flex-column">
            <p style="color: #EC407A">Kappa: {{ evaluationMeanMeasures.kappa }}<br></p>
            <p style="color: #EC407A">Accuracy: {{ evaluationMeanMeasures.accuracy }}<br></p>
            <p style="color: #EC407A">Recall: {{ evaluationMeanMeasures.recall }}<br></p>
            <p style="color: #EC407A">Precision: {{ evaluationMeanMeasures.precision }}<br></p>
            <p style="color: #EC407A">F1 Score: {{ evaluationMeanMeasures.fScore }}<br></p>
          </mdb-card-text>
          <mdb-card-text *ngIf="evaluationMeanMeasures.confirmationState == 1" class="flex-column text-success">
            <p>Kappa: {{ evaluationMeanMeasures.kappa }}<br></p>
            <p>Accuracy: {{ evaluationMeanMeasures.accuracy }}<br></p>
            <p>Recall: {{ evaluationMeanMeasures.recall }}<br></p>
            <p>Precision: {{ evaluationMeanMeasures.precision }}<br></p>
            <p>F1 Score: {{ evaluationMeanMeasures.fScore }}<br></p>
          </mdb-card-text>
        </mdb-card-body>
      </mdb-card>
    </div>


    </div>
    </div>
  </div>
  </div>
  <!-- Card -->
<!---->
  <div class="row d-flex justify-content-center mt-xl-5">
  <div class="col-9" style="display: block">
    <canvas mdbChart
            [chartType]="chartType"
            [datasets]="chartDatasets"
            [labels]="chartLabels"
            [colors]="chartColors"
            [options]="chartOptions"
            [legend]="true"
            (chartHover)="chartHovered($event)"
            (chartClick)="chartClicked($event)">
    </canvas>
  </div>
  </div>
  <div>
    <div class="m-2"><div class="row d-flex justify-content-center">
      <p style="color: #3a6ea5"><b>Variations of the Kappa and Mean Kappa Values</b></p>
    </div></div>

  </div>

  <div id="aboutAsips">
    <div class="m-lg-5"><div class="row d-flex justify-content-center">
      <h2 style="color: #0D446E"><b>Asips for Pulsar Astronomy</b></h2>
    </div></div>
    <div class="row d-flex justify-content-center">
      <div class="col-6">
        <p style="align-content: center">Pulsar stars are one of the most important keys to revealing the mysteries of the universe
          (<a href="https://www.nrao.edu/pr/2012/aaaspulsars/">More</a>). Currently, only 10% of pulsars have detected
          in our galaxy and it needs to detect the rest of the pulsars for explorations.
          And also, pulsars of the outside of the galaxy. Recently, Data Science methods were used to analyze
          characteristics of collected large amount of radio waves to find pulsars. <br>

          Asips is a system which demonstrate the use of a novel algorithm on
          <a href="https://archive.ics.uci.edu/ml/datasets/HTRU2">HTRU2</a> dataset. Also, Asips provide the capability
          of comparing those results with the results from other existing stream classification algorithms.<br>

          The algorithm is capable of learning from new confirmed data; it uses delayed progressive evaluator and
          developed according to kappa architecture
          (<a href="https://towardsdatascience.com/machine-learning-for-streaming-data-with-creme-dacf5fb469df">More about kappa architecture</a>).
          Thus, user can confirm the correctness of predictions, then model will update(learn) from new confirmed data.<br>

          Also, you can view and explore confirmed data <a routerLink="/view_pulsar">here</a> and <a routerLink="/view_pulsar_non_pulsar">here</a>.
          <br>
          <a routerLink="/help">Learn more about Asips...</a>
       </p>
      </div>
    </div>
    <div style="height: 10vh">

    </div>
  </div>
</main>

<!--<button (click)="switchChartData()"mdbBtncolor="primary">Change</button>-->
<!--Main Layout-->

